import { render, staticRenderFns } from "./IdleTimeCheckModal.vue?vue&type=template&id=07036532&scoped=true&"
import script from "./IdleTimeCheckModal.vue?vue&type=script&lang=js&"
export * from "./IdleTimeCheckModal.vue?vue&type=script&lang=js&"
import style0 from "./IdleTimeCheckModal.vue?vue&type=style&index=0&id=07036532&scoped=true&lang=scss&"
import style1 from "./IdleTimeCheckModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07036532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07036532')) {
      api.createRecord('07036532', component.options)
    } else {
      api.reload('07036532', component.options)
    }
    module.hot.accept("./IdleTimeCheckModal.vue?vue&type=template&id=07036532&scoped=true&", function () {
      api.rerender('07036532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/IdleTimeCheckModal.vue"
export default component.exports